export default __webpack_public_path__ + "static/media/Corsairs-treasure-01.48573670.png";